import { noop } from "lodash-es";
import type React from "react";
import { createContext } from "react";

import type { GameAnswer } from "./utils/answer";

export const GamePlayContext = createContext<{
  answers: GameAnswer[];
  addAnswer: React.Dispatch<GameAnswer>;
  blastConfetti: () => void;
  endGame: (answer?: GameAnswer) => void;
  addRewardTime: React.Dispatch<number>;
}>({
  answers: [],
  addAnswer: noop,
  blastConfetti: noop,
  endGame: noop,
  addRewardTime: noop,
});
